import { popActiveLoadingDialogs } from "@/store/loading-dialog-utils"
import { ProjectStyleTypes, showStyleNamingDialog, StyleDraft } from "./style-state"
import { DialogProps } from "@/components/ui/Dialog"
import { getDuplicateStyleNameErrorMessage } from "./style-service"
import { publishStyleDraft, PublishStyleDraftResult } from "./publish-style"

export const showDuplicateStyleNameRecoveryDialog = (options: {
	styleDraft: StyleDraft
	styleName?: string
	projectStyleType: ProjectStyleTypes
	onDuplicateNameResolved: (result: PublishStyleDraftResult) => void | Promise<void>
	trackingViewName?: string
	dialogProps?: Partial<DialogProps>
}) => {
	popActiveLoadingDialogs()

	const styleDraft = options.styleDraft
	const styleName = options.styleName || styleDraft.name
	styleDraft.name = styleName

	showStyleNamingDialog(
		{
			...options.dialogProps,
			trackingViewName:
				options.trackingViewName ??
				options.dialogProps?.trackingViewName ??
				"style_naming_dialog",
		},
		styleDraft,
		options.projectStyleType,
		async (style) => {
			const publishResult = await publishStyleDraft(style)
			await options.onDuplicateNameResolved(publishResult)
		},
		getDuplicateStyleNameErrorMessage(styleName),
	)
}
